import React, { useEffect, useState } from 'react'
import { fetchAgentPermissions } from '../../../lib/kbAgentApi'
import AgentAccessDrawer from './AgentAccessDrawer'
import AgentChatDrawer from './AgentChatDrawer'
import AgentHeroGlassCard from './AgentHeroGlassCard'
import { manifestClientsToOptions } from './agentChatLayout'

/**
 * Hero orchestration — glass card + My Access / Let's chat drawers.
 */
export default function AgentHeroCard({ clientId, includePersonal, canOpenWiki }) {
  const [permissions, setPermissions] = useState(null)
  const [permError, setPermError] = useState('')
  const [permLoading, setPermLoading] = useState(true)
  const [drawerMode, setDrawerMode] = useState(null)

  const loadPermissions = async () => {
    setPermLoading(true)
    setPermError('')
    try {
      const perm = await fetchAgentPermissions()
      setPermissions(perm)
    } catch (e) {
      setPermError(e?.message ?? 'Failed to load permissions')
    } finally {
      setPermLoading(false)
    }
  }

  useEffect(() => {
    loadPermissions()
  }, [])

  const openChat = () => {
    loadPermissions()
    setDrawerMode('chat')
  }

  const openAccess = () => {
    loadPermissions()
    setDrawerMode('access')
  }

  const allowedClients = manifestClientsToOptions(permissions)
  const personalKbAvailable = permissions?.personal_kb_available === true

  return (
    <>
      <AgentHeroGlassCard
        manifest={permissions}
        permLoading={permLoading}
        permError={permError}
        onMyAccess={openAccess}
        onLetsChat={openChat}
      />

      <AgentAccessDrawer
        open={drawerMode === 'access'}
        onClose={() => setDrawerMode(null)}
        permissions={permissions}
        permError={permError}
        permLoading={permLoading}
      />

      <AgentChatDrawer
        open={drawerMode === 'chat'}
        onClose={() => setDrawerMode(null)}
        clientId={clientId}
        includePersonal={includePersonal}
        allowedClients={allowedClients}
        personalKbAvailable={personalKbAvailable}
        canOpenWiki={canOpenWiki}
      />
    </>
  )
}
